// controller-reserved-ticket-ids.ts
//
// The 9xxx range is reserved for controller-owned sessions (review-local-v1 /
// review-clean-v1), well clear of bootstrap (T-000x) and plan-authored
// (T-01xx) ids. R-07: a worker `create` proposal could pick one of these ids
// to dodge G2 (the guard only re-checks scope for a normal ticket) and make
// the real review session look like it had already run — a separate id, not
// a second attempt on an existing one, because journal events and attempt
// state are keyed by ticket id. This module is the SINGLE source for the
// dial, deliberately free of a dependency on the dispatch layer (guard,
// applier, review-candidate-session) — it only exports data.
export const REVIEW_CANDIDATE_TICKET_ID = "T-9001";
export const CLEAN_REVIEW_CANDIDATE_TICKET_ID = "T-9002";

export const CONTROLLER_RESERVED_TICKET_IDS: readonly string[] = [
  REVIEW_CANDIDATE_TICKET_ID,
  CLEAN_REVIEW_CANDIDATE_TICKET_ID,
];

export function isControllerReservedTicketId(id: string): boolean {
  return CONTROLLER_RESERVED_TICKET_IDS.includes(id);
}
